function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "avatar-sharo-2x-a",
  width: 95,
  height: 95,
  rx: 22
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-sharo-2x-b",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ACDAF2",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#86BDE5",
  offset: "57.569%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#62BFE7",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "avatar-sharo-2x-c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#avatar-sharo-2x-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#avatar-sharo-2x-a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#avatar-sharo-2x-b)",
  mask: "url(#avatar-sharo-2x-c)",
  d: "M70.833 6.5H36.91c-1.262 0-2.284 1.023-2.284 2.284v45.048c0 10.1.36 16.47 13.704 16.47 12.87 0 17.576-11.513 18.435-24.41.054-.81.74-1.437 1.555-1.437h7.41c.866 0 1.576.71 1.554 1.574-.447 17.9-8.612 34.13-28.352 34.13-17.552 0-23.323-6.37-23.323-17.67V7.22c0-.398-.325-.72-.72-.72C14.73 6.5 6.5 14.733 6.5 24.888V70.83c0 9.76 7.91 17.67 17.67 17.67h46.66c9.758 0 17.668-7.91 17.668-17.668V24.168C88.5 14.41 80.59 6.5 70.833 6.5"
}));

var SvgSharoDark = function SvgSharoDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSharoDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sharo-dark.c9b92dba.svg";
export { ForwardRef as ReactComponent };